export const sanitizeUrl = (url) => {
  try {
    if (!url) return url;

    return url
      ?.replace(/[^a-zA-Z0-9 -]/g, '')
      ?.replace(/\s+/g, '-')
      ?.toLowerCase();
  } catch (error) {
    console.error('failed to sanitize url', { error, url });
    return url;
  }
};
